import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import { CreateFlatStore } from "../../hooks/useCreateFlatStore";

interface Props {
  store: CreateFlatStore;
}

const AvailabilityStep: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const {
    textNeutralDefault,
    textNeutralMuted,
    accentColor,
    containerNeutralLightMedium,
  } = useColors();

  const formatDate = (date: Date | undefined): string => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
  };

  return (
    <StepWrapper
      title={
        t("flats_tab.add_flat.flat_permanent_title") ||
        "When is the room available?"
      }
    >
      <div className="space-y-7">
        {/* Permanent toggle */}
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium" style={{ color: textNeutralDefault }}>
              {t("flats_tab.add_flat.flat_permanent_subtitle") ||
                "Permanent stay"}
            </p>
            <p className="text-sm mt-0.5" style={{ color: textNeutralMuted }}>
              {store.isPermanent
                ? t("flats_tab.add_flat.select_move_in_date") ||
                  "Select move-in date"
                : t("flats_tab.add_flat.select_date_range") ||
                  "Select date range"}
            </p>
          </div>
          <button
            onClick={() => store.setIsPermanent(!store.isPermanent)}
            className="cf-toggle"
            style={{
              backgroundColor: store.isPermanent
                ? accentColor
                : containerNeutralLightMedium,
            }}
          >
            <span
              className="cf-toggle-knob"
              data-on={store.isPermanent ? "true" : "false"}
            />
          </button>
        </div>

        {/* From date */}
        <div>
          <label
            className="block text-sm mb-2 font-medium"
            style={{ color: textNeutralMuted }}
          >
            {t("flats_tab.add_flat.from_date") || "Available from"}
          </label>
          <input
            type="date"
            value={formatDate(store.fromDate)}
            onChange={(e) =>
              store.setFromDate(
                e.target.value ? new Date(e.target.value) : undefined,
              )
            }
            min={new Date().toISOString().split("T")[0]}
            className="cf-input-boxed"
            style={{ color: textNeutralDefault }}
          />
        </div>

        {/* To date (only for temporary) */}
        {!store.isPermanent && (
          <div>
            <label
              className="block text-sm mb-2 font-medium"
              style={{ color: textNeutralMuted }}
            >
              {t("flats_tab.add_flat.to_date") || "Available until"}
            </label>
            <input
              type="date"
              value={formatDate(store.toDate)}
              onChange={(e) =>
                store.setToDate(
                  e.target.value ? new Date(e.target.value) : undefined,
                )
              }
              min={
                store.fromDate
                  ? new Date(store.fromDate.getTime() + 86400000)
                      .toISOString()
                      .split("T")[0]
                  : new Date().toISOString().split("T")[0]
              }
              className="cf-input-boxed"
              style={{ color: textNeutralDefault }}
            />
          </div>
        )}
      </div>
    </StepWrapper>
  );
};

export default AvailabilityStep;
